// removed by extract-text-webpack-plugin
module.exports = {"rbc-calendar":"rbc-calendar","filter-by":"filter-by","filter-by-field":"filter-by-field","rbc-day-bg":"rbc-day-bg","classtop-rbc-toolbar":"classtop-rbc-toolbar","react-tabs__tab-list":"react-tabs__tab-list","add-lesson":"add-lesson","navigate-date":"navigate-date","change-date-button":"change-date-button","change-date-arrow":"change-date-arrow","date-label":"date-label"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/pages/Schedule/Schedule.scss
// module id = 1S4H
// module chunks = 0